(function () {
  function updateBadge(count) {
    var cartLink = document.querySelector('.wp-nav__icon--cart');
    if (!cartLink) return;
    var badge = cartLink.querySelector('.wp-nav__badge');
    if (count > 0) {
      if (badge) {
        badge.textContent = count;
      } else {
        badge = document.createElement('span');
        badge.className = 'wp-nav__badge';
        badge.setAttribute('aria-hidden', 'true');
        badge.textContent = count;
        cartLink.appendChild(badge);
      }
      cartLink.setAttribute('aria-label', 'Cart (' + count + ' items)');
    } else {
      if (badge) badge.remove();
      cartLink.setAttribute('aria-label', 'Cart');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wp-product-card__atc[data-vid]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var vid = parseInt(btn.dataset.vid, 10);
    if (!vid || btn.disabled) return;

    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          btn.textContent = data.description || 'Error';
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2500);
          return;
        }
        btn.textContent = 'Added ✓';
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateBadge(cart.item_count); });
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000);
      })
      .catch(function () {
        btn.textContent = 'Error';
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2500);
      });
  });
})();
